module.exports = __webpack_public_path__ + "media/custom/images/img40-c1569be3c95c6e7e868d49e2ad466e2b.jpg";